import { useContext } from "react";
import { useTranslation } from "react-i18next";
import useLanguage from "../useLanguage";

import { DataContext } from "../DataContext";

const usePrint = () => {
  const { selectedSupplier } = useContext(DataContext);

  const { currentDirection } = useLanguage();
  const { t } = useTranslation("general");

  const handlePrint = (content) => {
    const newWindow = window.open("", "_blank");

    if (newWindow) {
      newWindow.document.write(`
        <html>
          <head>
            <title>Print</title>
            <link rel="preconnect" href="https://fonts.googleapis.com" />
            <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin />
            <link
              href="https://fonts.googleapis.com/css2?family=Tajawal:wght@200;300;400;500;700;800;900&display=swap"
              rel="stylesheet"
            />

            <link rel="stylesheet" type="text/css" href="/ehsibly.min.css">
            <link rel="stylesheet" type="text/css" href="/print.css">
            <style>
              body {
                direction: ${currentDirection === "rtl" ? "rtl" : "ltr"};
                font-family:${
                  currentDirection === "rtl" ? "Tajawal, serif" : ""
                };
              }
            </style>
          </head>
          <body>
            ${content}
            <script>
              window.onload = function() {
                window.print(); // Trigger the print dialog
                window.onafterprint = function() { window.close(); }; // Close after printing
              };
            </script>
          </body>
        </html>
      `);
      newWindow.document.close(); // Close the document to finish writing
    }
  };

  const handlePrintRows = (titles, selectedRows) => {
    const newWindow = window.open("", "_blank");

    const content = `
  <table class="i-table">
    <thead class="table-head">
      <tr>
      ${titles
        .map(
          (title) => `
            <th class="bold-text cell-title ${title.value} ${
            title.value !== "invoiceNumber" ? "mobile-hider" : ""
          }">
              ${t(title.title)} ${
            title.value === "amountInSupCur"
              ? `${selectedSupplier?.currency}`
              : ""
          }
            </th>
          `
        )
        .join("")}      
      </tr>
    </thead>
    <tbody class="table-body">
      ${selectedRows
        ?.map((row) =>
          !row.canceled
            ? `
          <tr>
            <td class="cell invoice-number ${
              currentDirection === "ltr"
                ? "rounded-first-cell"
                : "rounded-last-cell"
            }">
              ${`<a href="/invoice/${row?.id}" class="link">
                      <p>${row?.invoiceNumber}</p>
                </a>`}
            </td>
            <td class="cell mobile-hider">${row.amount}</td>
            <td class="cell mobile-hider">${row.amountCurrency}</td>
            <td class="cell mobile-hider">${row.bankName}</td>
            <td class="cell mobile-hider">${row.amountInSupCur}</td>
            <td class="cell mobile-hider">${
              row.date ? new Date(row.date).toISOString().split("T")[0] : ""
            }</td>
            <td class="cell notes-cell mobile-hider ${
              currentDirection === "ltr"
                ? "rounded-last-cell"
                : "rounded-first-cell"
            }">
              ${row.notes}
            </td>
          </tr>
        `
            : ""
        )
        .join("")}
    </tbody>
  </table>
`;

    if (newWindow) {
      newWindow.document.write(`
        <html>
          <head>
            <title>Print</title>
            <link rel="preconnect" href="https://fonts.googleapis.com" />
            <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin />
            <link
              href="https://fonts.googleapis.com/css2?family=Tajawal:wght@200;300;400;500;700;800;900&display=swap"
              rel="stylesheet"
            />

            <link rel="stylesheet" type="text/css" href="/ehsibly.min.css">
            <link rel="stylesheet" type="text/css" href="/print.css">
            <style>
              body {
                direction: ${currentDirection === "rtl" ? "rtl" : "ltr"};
                font-family:${
                  currentDirection === "rtl" ? "Tajawal, serif" : ""
                };
              }
            </style>
          </head>
          <body>
              ${content}
            <script>
              window.onload = function() {
                window.print(); // Trigger the print dialog
                window.onafterprint = function() { window.close(); }; // Close after printing
              };
            </script>
          </body>
        </html>
      `);
      newWindow.document.close(); // Close the document to finish writing
    }
  };

  return { handlePrint, handlePrintRows };
};

export default usePrint;
